import React from 'react'

import { Grid } from '@mui/material'

import { PostTypeEnum } from '@professocial/professocialTypes/types/commonTypes'
import Headline from './Headline'
import Text from './Text'
import Image from './Image'
import LinkPost from './LinkPost'
import VideoPost from './VideoPost'
import { IPostElementProps } from '../../../../types/types'

interface IProps extends IPostElementProps {
  postType: PostTypeEnum | undefined
}

const PostContent: React.FC<IProps> = (props) => {
  const post = props.post
  const postType = props.postType

  return (
    <Grid container>
      {/* Messagepost */}
      {postType === PostTypeEnum.MESSAGE &&
        <Grid item xs={12} sx={{ mt: 3, minHeight: '350px' }}>
          <Headline
            networkPageId={props.networkPageId}
            post={post}
            networkType={props.networkType}
            value={post.content.headline}
            view={props.view}
            size={props.size}
          />
          <Text
            networkPageId={props.networkPageId}
            post={post}
            networkType={props.networkType}
            value={post.content.text}
            view={props.view}
            size={props.size}
          />
        </Grid>}

      {/* Photopost */}
      {postType === PostTypeEnum.PHOTO &&
        <Grid item xs={12} sx={{ mt: 3, minHeight: '350px' }}>
          <Headline
            networkPageId={props.networkPageId}
            post={post}
            networkType={props.networkType}
            value={post.content.headline}
            view={props.view}
            size={props.size}
          />
          {post.content.text &&
            <Text
              networkPageId={props.networkPageId}
              post={post}
              networkType={props.networkType}
              value={post.content.text}
              view={props.view}
              size={props.size}
            />}
          {post.content.image &&
            <Image
              style={{ maxHeight: '300px' }}
              data={post.content.image.url}
              view={props.view}
            />}
        </Grid>}
      {/* Linkpost */}
      {postType === PostTypeEnum.LINK &&
        <Grid item xs={12} sx={{ mt: 3, minHeight: '350px' }}>
          <Headline
            networkPageId={props.networkPageId}
            post={post}
            networkType={props.networkType}
            value={post.content.headline}
            view={props.view}
            size={props.size}
          />
          {post.content.text &&
            <Text
              networkPageId={props.networkPageId}
              post={post}
              networkType={props.networkType}
              value={post.content.text}
              view={props.view}
              size={props.size}
            />}
          {post.content.link &&
            <LinkPost
              networkPageId={props.networkPageId}
              post={post}
              networkType={props.networkType}
              value={post.content.link}
              view={props.view}
            />}
        </Grid>}
      {/* Videopost */}
      {postType === PostTypeEnum.VIDEO &&
        <Grid item xs={12} sx={{ mt: 3, minHeight: '350px' }}>
          {post.content.text &&
            <Text
              networkPageId={props.networkPageId}
              post={post}
              networkType={props.networkType}
              value={post.content.text}
              view={props.view}
              size={props.size}
            />}
          {post.content.video &&
            <VideoPost
              value={post.content.video}
              view={props.view}
            />}
        </Grid>}
    </Grid>
  )
}

export default PostContent
